import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import { handleActions } from '@gef-ui/utils/fsaActions';
import map from "ramda/es/map";
import mergeDeepRight from "ramda/es/mergeDeepRight";
import mapKeys from "ramda-extension/es/mapKeys";
import { fieldStateActions } from '../../constants';
import { composeAction } from '../../utils';
const updateFieldState = {
    next (state, { payload }) {
        const payloadWithState = map((res)=>({
                state: res
            }), payload);
        return mergeDeepRight(state, payloadWithState);
    }
};
const setAllFieldsValid = {
    next (state) {
        const newState = map(()=>({
                state: {
                    valid: 'VALID',
                    pristine: true
                }
            }), state);
        return mergeDeepRight(state, newState);
    }
};
const fieldStateActionsMap = {
    [fieldStateActions.SET_ALL_FIELDS_VALID]: setAllFieldsValid,
    [fieldStateActions.UPDATE_FIELDS_STATE]: updateFieldState
};
export default memoizeWithAllArguments((formName, defaultState = {})=>handleActions(mapKeys(composeAction(formName), fieldStateActionsMap), defaultState));
